import React, { useEffect, useRef, useState } from "react";
import { isBlockedUser } from "../Utils/userFilters";

const CustomizeModal = ({ selectedUsers, onSave, allUsers }) => {
  const [members, setMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [hideCustomizeModal, setHideCustomizeModal] = useState(false);

  const handleSave = () => {
    if (onSave) {
      onSave({ title, description, members });
    }

    setHideCustomizeModal(true);
  };

  const modalRef = useRef(null);

  useEffect(() => {
    if (selectedUsers) {
      setMembers(selectedUsers);
    }
  }, [selectedUsers]);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (!modalElement) return;

    const handleHidden = () => {
      setTitle("");
      setDescription("");
      setSearchTerm("");
      // Reset members to original selected users if we want to discard unsaved changes
      setMembers(selectedUsers || []);
    };

    modalElement.addEventListener("hidden.bs.modal", handleHidden);
    return () => {
      modalElement.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, [selectedUsers]);

  const handleRemoveMember = (id) => {
    setMembers((prevMembers) =>
      prevMembers.filter((member) => member.id !== id),
    );
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleAddMember = (user) => {
    if (!members.some((m) => m.id === user.id)) {
      setMembers((prev) => [...prev, user]);
    }
    setSearchTerm("");
  };

  const filteredUsers = (allUsers || [])
    .filter((u) => u?.name && !isBlockedUser(u))
    .filter(
      (u) =>
        u.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !members.some((m) => m.id === u.id),
    );

  return (
    <div
      className="modal delete-account-modal fade"
      ref={modalRef}
      id="customizeChatModal"
      tabIndex="-1"
      aria-labelledby="customizeChatModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header mb-4 d-flex justify-content-center align-items-center">
            <h1
              id="customizeChatModalLabel"
              className="modal-title text-heading-chat-modal new-message-heading"
            >
              Customize chat
            </h1>
            <button
              type="button"
              className="btn-close btn-close-white position-absolute end-0 me-3"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row gap-4">
              <div className="col-md-12">
                <div className="textfield-1">
                  <input
                    type="text"
                    className="text-body-b2"
                    value={title}
                    placeholder=""
                    onChange={handleTitleChange}
                  />
                  <label
                    className="text-body-b2"
                    style={{ backgroundColor: "#132534" }}
                  >
                    Title
                  </label>
                </div>
              </div>

              <div className="col-md-12">
                <div className="textfield-1">
                  <textarea
                    className="text-body-b2"
                    placeholder=""
                    value={description}
                    onChange={handleDescriptionChange}
                  />
                  <label
                    className="text-body-b2"
                    style={{ backgroundColor: "#132534" }}
                  >
                    Description
                  </label>
                </div>
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search users..."
                  value={searchTerm}
                  style={{ background: "#132534", color: "white" }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <div
                    className="mt-3 result-box"
                    style={{ maxHeight: "150px", overflowY: "auto" }}
                  >
                    {filteredUsers.length > 0 ? (
                      filteredUsers.map((user) => (
                        <div
                          key={user.id}
                          className="d-flex align-items-center justify-content-between p-2 result-individual mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleAddMember(user)}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={user.profileImage}
                              alt={user.name}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                              }}
                            />
                            <span className="text-white">{user.name}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="p-2" style={{ color: "#fff" }}>
                        No users found
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div
                className="add-member-section"
                style={{ backgroundColor: "#132534" }}
              >
                <div className="member-container" style={{ minHeight: "60px" }}>
                  <div className="d-flex align-items-center gap-1 gap-sm-2 h-100 flex-wrap">
                    {members &&
                      members.map((member) => (
                        <div className="member-chip w-auto" key={member.id}>
                          <img
                            src={member.profileImage}
                            alt={member.name}
                            className="member-avatar"
                          />
                          <span className="member-name">{member.name}</span>
                          <img
                            src="/icons/cross.svg"
                            className="tag-remove remove-member"
                            alt=""
                            style={{ width: "10px", height: "10px" }}
                            onClick={() => handleRemoveMember(member.id)}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex gap-3 mt-4 justify-content-center">
              <button
                className="btn-1 btn-1-primary px-3"
                style={{ width: "182px" }}
                data-bs-dismiss="modal"
                onClick={handleSave}
              >
                Save
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                className="btn-1 btn-1-primary px-3"
                style={{ width: "182px", backgroundColor: "#eb5757" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizeModal;
